import { apm } from '@elastic/apm-rum';
import { useEffect } from 'react';

interface UseConfigureApmParams {
  userData?: {
    name: string;
    email: string;
    teamId: string;
  };
}

export const useConfigureApm = ({ userData }: UseConfigureApmParams) => {
  useEffect(() => {
    if (userData) {
      apm.setUserContext({
        id: userData.teamId,
        email: userData.email,
        username: userData.name,
      });
    }

    return () => {
      apm.setUserContext({
        id: '',
        email: '',
        username: '',
      });
    };
  }, [userData?.teamId]);
};
